document.addEventListener('DOMContentLoaded', function () {
    // === Tab Switching Logic ===
    const tabLinks = document.querySelectorAll('.tab-link');
    tabLinks.forEach(link => {
        link.addEventListener('click', function () {
            const container = this.closest('.product-tabs-container');
            if (!container) return; // Prevent errors if structure changes

            const tabId = this.getAttribute('data-tab');

            container.querySelectorAll('.tab-link').forEach(l => l.classList.remove('active'));
            container.querySelectorAll('.tab-content').forEach(c => c.classList.remove('active'));

            this.classList.add('active');
            const activeContent = document.getElementById(tabId);
            if (activeContent) {
                activeContent.classList.add('active');
            }
        });
    });

    // === Carousel Logic ===
    const arWrapper = document.querySelector('.product-gallery__ar-wrapper');
    const carouselList = document.querySelector('.product-gallery__thumbnail-list');
    
    // Guard clause in case carousel elements are missing on the page
    if (!arWrapper || !carouselList) return;

    const allItems = Array.from(carouselList.querySelectorAll('.product-gallery__thumbnail'));
    const btnUp = document.querySelector('.thumb-nav-btn.up');
    const btnDown = document.querySelector('.thumb-nav-btn.down');
    
    const visibleCount = 4;
    let currentIndex = 0;
    let itemHeight = 0;

    function calculateLayout() {
        const wrapperHeight = arWrapper.offsetHeight;
        itemHeight = wrapperHeight / visibleCount;
        carouselList.style.maxHeight = wrapperHeight + 'px';

        // Keep scroll position aligned with currentIndex on resize
        carouselList.scrollTop = currentIndex * itemHeight;
        
        updateNavButtonsVisibility();
    }

    function updateNavButtonsVisibility() {
        if (allItems.length <= visibleCount) {
            if (btnUp) btnUp.style.display = 'none';
            if (btnDown) btnDown.style.display = 'none';
        } else {
            if (btnUp) btnUp.style.display = '';
            if (btnDown) btnDown.style.display = '';
        }
    }

    function setupNavButtons() {
        if (btnUp) {
            btnUp.addEventListener('click', () => {
                if (currentIndex > 0) {
                    currentIndex--;
                    carouselList.scrollTo({
                        top: currentIndex * itemHeight,
                        behavior: 'smooth'
                    });
                }
            });
        }

        if (btnDown) {
            btnDown.addEventListener('click', () => {
                if (currentIndex < allItems.length - visibleCount) {
                    currentIndex++;
                    carouselList.scrollTo({
                        top: currentIndex * itemHeight,
                        behavior: 'smooth'
                    });
                }
            });
        }
    }

    // Initialize layout and event listeners
    calculateLayout();
    setupNavButtons();

    // Debounce the resize handler slightly for better performance
    let resizeTimeout;
    window.addEventListener('resize', () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(calculateLayout, 100);
    });
});